// Lucide icon: printer (https://lucide.dev/icons/printer)
import { Printer } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconPrint = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Printer />
    </IconComponentStyled>
  )
}
